/**
 * KB AI enhance — tone chip selection, Accept/Cancel.
 *
 * Tone chips: clicking a [data-tone] chip inside an AI popover toggles
 *   chip-active and syncs the hidden [name="_ai_tone"] input.
 *
 * current_text is sent via hx-vals='js:...' on the Enhance button — no JS
 *   event listener needed.
 *
 * Accept: copies the original suggestion text (from data-ai-text on the
 *   card) into the target textarea (id from data-ai-target), dispatches
 *   input + blur events so autoresize and the existing blur-save flow
 *   pick up the change, then clears the wrapper.
 *
 * Cancel: clears the wrapper.
 *
 * Spinner: handled automatically by loading.js (hx-disabled-elt="this" on
 *   the Enhance button is sufficient).
 */

(function () {

    // ── Tone chip toggle ──────────────────────────────────────────────────

    document.body.addEventListener('click', function (e) {
        var chip = e.target.closest('.chip[data-tone]');
        if (!chip) return;

        var popover = chip.closest('.dropdown-menu');
        if (!popover) return;

        var hidden = popover.querySelector('[name="_ai_tone"]');
        if (!hidden) return; // not an AI popover — bail

        popover.querySelectorAll('.chip[data-tone]').forEach(function (c) {
            c.classList.remove('chip-active');
        });
        chip.classList.add('chip-active');
        hidden.value = chip.getAttribute('data-tone');
    });

    // ── Accept / Cancel ───────────────────────────────────────────────────

    document.body.addEventListener('click', function (e) {
        var accept = e.target.closest('[data-ai-accept]');
        var cancel = e.target.closest('[data-ai-cancel]');
        if (!accept && !cancel) return;

        var card = (accept || cancel).closest('.card--accent');
        if (!card) return;

        if (accept) {
            // Text accept — copy into target textarea, trigger blur-save
            var targetId = card.getAttribute('data-ai-target');
            var textarea = targetId ? document.getElementById(targetId) : null;
            var text = card.getAttribute('data-ai-text') || '';
            if (textarea && text) {
                textarea.value = text;
                textarea.dispatchEvent(new Event('input', { bubbles: true }));
                textarea.dispatchEvent(new Event('blur', { bubbles: true }));
            }

            // Metadata accept — POST to save endpoint, swap details card
            var metadataUrl = card.getAttribute('data-ai-metadata-url');
            var metadataJson = card.getAttribute('data-ai-metadata');
            var detailsCardId = card.getAttribute('data-ai-details-card');
            if (metadataUrl && metadataJson) {
                try {
                    var meta = JSON.parse(metadataJson);
                    htmx.ajax('POST', metadataUrl, {
                        target: detailsCardId ? '#' + detailsCardId : null,
                        swap: 'outerHTML',
                        values: {
                            embedding_phrases: meta.embedding_phrases || '',
                            tags: (meta.tags || []).join(','),
                            group: meta.group || ''
                        }
                    });
                } catch (err) {
                    console.error('Failed to save metadata:', err);
                    if (window.SeeMe && SeeMe.toast) SeeMe.toast.error('Failed to save metadata');
                }
            }
        }

        var wrapper = card.parentElement;
        if (wrapper) wrapper.innerHTML = '';
    });

})();
